import React,{ useState } from "react"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg"
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable"
import useModuleData from "../../../disaster/hooks/useFetchItems"
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute"
import useModalHandlers from "../../../disaster/hooks/useModalHandler"
import useChangeHandler from "../../../disaster/hooks/useChangeHandler"
import useGetAttributes from "../../../disaster/hooks/useGetAttributes"
import useDeleteItem from "../../../disaster/hooks/useDeleteItem"
import { Table } from "antd"
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator"
import UseUpdate from "../../../disaster/hooks/UseUpdate"
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal"
import NewLoader from "../../../../../components/styled-components/loader/NewLoader"
import { getAllColumns } from "./AllColumnsData"
import FormInputFields from "./Form"
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator"


const moduleNames = [
  "Business Interests",
  "Business Assets",
  "Financial Statements",
  "Tax Returns",
  "Partnership Agreements",
  "Client Lists",
  "Intellectual Property",
]

export default function BusinessInterests() {
  const [loading, setLoading] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalTitle, setModalTitle] = useState("")
  const [moduleName, setModuleName] = useState("Business Interests")
  const [formData, setFormData] = useState(null) // State for DisabilityFormCreator
  const [modalFormData, setModalFormData] = useState(null) // New state for CustomModal
  const [attributesData, setAttributesData] = useState(null)
  const history = useHistory()

  const { fetchData, disasterAttributeData, formatModuleKey, setTableData, setToUpdate, toUpdate, tableData } =
    useModuleData(moduleNames, setLoading)

  const tableDataObj = {
    "Business Interests": tableData.businessInterestsData,
    "Business Assets": tableData.businessAssetsData,
    "Financial Statements": tableData.financialStatementsData,
    "Tax Returns": tableData.taxReturnsData,
    "Partnership Agreements": tableData.partnershipAgreementsData,
    "Client Lists": tableData.clientListsData,
    "Intellectual Property": tableData.intellectualPropertyData,
  }

  const { attributes, disasterAttribute } = useGetAttributes(moduleNames, setLoading)

  console.log("Attributes Data:", attributes)

  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setModalFormData, // Using the new state for modal form data
    setAttributesData,
  )

  const { updateRecord, error } = UseUpdate(modalFormData, setFormData, fetchData, formatModuleKey, setTableData, setLoading)
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading)
  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord)

  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setModalFormData) 
console.log("Modal form data",modalFormData);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    modalFormData, 
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading,
  )

  const Tables = [
    { title: "Business Assets", key: 1 },
    { title: "Financial Statements", key: 2 },
    { title: "Tax Returns", key: 3 },
    { title: "Partnership Agreements", key: 4 },
    { title: "Client Lists", key: 5 },
    { title: "Intellectual Property", key: 6 },
  ]

  const AddContact = () => {
    history.push("/client/plan")
  }
  const AddDocument = () => {
    history.push("/orgainzer/important-document")
  }

  const cleanedAttributes = Array.isArray(attributes)
    ? attributes
        .filter((item) => item !== null && typeof item === "object" && item.attributes)
        .reduce((acc, curr) => {
          acc[curr.name] = curr.attributes
          return acc
        }, {})
    : {}

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="parent-title">Business Interests</h2>
          <ToolTipCreator name={"Divorce_Business_Interests"}/>
        </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon || "/placeholder.svg"} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      <FormInputFields />
      {Tables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setModalFormData} // Using the new state for modal form data
          formData={modalFormData}
          onClick={() => showModal(table.title)}
        >
          <Table columns={AllColumnsData[table.title]} dataSource={tableDataObj[table.title]} />
        </CollapseableTable>
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={modalFormData && modalFormData} // Using the new state for modal form data
          handleItemsInfoImageChange={modalFormData}
          loading={loading}
        />
      </div>
      <NewLoader isLoading={loading} />
    </div>
  )
}